import React from "react";
import "./Settlement.css";
import { useSelector } from "react-redux";

function SettlementTable({ dataItem, userData }) {
  const role = useSelector((store) => store.userReducer.role);

  return (
    <div className="table-main-report">
      <table className="table-user-management" id="transaction-table">
        <thead className="table-user-report">
          <tr>
            {(role === "super" || role === "operation") && (
              <td>
                <p className="user-table-head-report">User Name</p>
              </td>
            )}
            <td>
              <p className="user-table-head-report">Amount Paid</p>
            </td>
            <td>
              <p className="user-table-head-report">Amount Unpaid</p>
            </td>
            <td>
              <p className="user-table-head-report">Chargeback Initated</p>
            </td>
          </tr>
        </thead>

        <tbody>
          {dataItem &&
            dataItem.length > 0 &&
            dataItem.map((item) => {
              return (
                <tr className="user-table-head-report">
                  {(role == "super" || role == "operation") && (
                    <td>
                      <p className="table-user-data-report order-break" style={{width:"9rem"}}>
                        {item?.userName || item?.userId}
                        {/* {item?.userId} */}
                      </p>
                    </td>
                  )}
                  <td>
                    <p className="table-user-data-report order-break">
                      {Number(item?.amountPaid).toFixed(2)|| "0"}
                    </p>
                  </td>
                  <td>
                    <p className="table-user-data-report order-break">
                      {Number(item?.amountToBePaid).toFixed(2)|| "0"}
                    </p>
                  </td>

                  <td>
                    <p className="table-user-data-report order-break">0</p>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
}

export default SettlementTable;
